var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.fields.items),function(item){return _c('li',{key:item.id},[_c('div',{staticClass:"field-link"},[_c('sc-link',{attrs:{"field":item.fields.link}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }